import { render, staticRenderFns } from "./RelatorioLogDisciplina.vue?vue&type=template&id=5981fe96&scoped=true"
import script from "./RelatorioLogDisciplina.vue?vue&type=script&lang=js"
export * from "./RelatorioLogDisciplina.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogDisciplina.vue?vue&type=style&index=0&id=5981fe96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5981fe96",
  null
  
)

export default component.exports